export enum RoutesType {
  NotFoundPage = '*',
  Main = '/',
  MitePolicy = '/mite-policy',
  CancerProtection = '/cancer-protection',
  HealthAL = '/healthAL',
  FeedbackMaxBot = '/feedback-max-bot',
  Feedback = '/feedback'
}
